export default "__VITE_ASSET__Blz__ERb__"